import React from 'react';
import { tripFactsheetUrl } from '@koob/utils';
import { useTripFilters } from '../hooks/useTripStoreSelectors';

interface TripHotelCardHeaderProps {
  name: string;
  address?: string;
  hotelId?: string | number;
  isForTrip: boolean;
  locale?: string;
}

/** The card's name — a link to the hotel's own page when `isForTrip` — and its address. */
export default function TripHotelCardHeader({
  name,
  address,
  hotelId,
  isForTrip,
  locale,
}: TripHotelCardHeaderProps) {
  const tripFilters: any = useTripFilters();

  return (
    <>
      {isForTrip ? (
        <a
          href={tripFactsheetUrl(`/hotels/${hotelId}`, {
            locale,
            tripId: tripFilters?.tripId,
          })}
          target="_blank"
          className="underline hover:text-blue-700"
          rel="noreferrer"
        >
          <div className="font-medium truncate">{name}</div>
        </a>
      ) : (
        <div className="font-medium truncate">{name}</div>
      )}

      {address && (
        <div className="mt-0.5 text-gray-500 text-sm flex space-x-1">
          <div className="truncate">{address}</div>
        </div>
      )}
    </>
  );
}
